import questionGroupService from '@/services/questionGroup.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		questionGroups: [],
		listQuestionGroups: [],
		questionGroup: {},
		searchParams: {
			name: '',
			orderBy: 'Name',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_QUESTIONGROUPS(state, questionGroups) {
			state.questionGroups = questionGroups;
		},
		SET_LIST_QUESTIONGROUPS(state, questionGroups) {
			state.listQuestionGroups = questionGroups;
		},
		SET_QUESTIONGROUP(state, questionGroup) {
			state.questionGroup = questionGroup;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getQuestionGroup({ commit }, questionGroupId) {
			return await questionGroupService
				.getQuestionGroup(questionGroupId)
				.then(data => {
					commit('SET_QUESTIONGROUP', data);
				})
				.catch(err => {
					console.log('Error getting questionGroup: ', err);
				});
		},

		async getQuestionGroups({ state, commit, dispatch, rootGetters }) {
			dispatch('appStore/setLoading', 1, { root: true });

			state.searchParams.companyId = rootGetters['user/getActiveCompany'].id;
			state.searchParams.customerId = rootGetters['user/getActiveCustomer'].id;
			
			return await questionGroupService
				.getQuestionGroups(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;
					console.log(paginationValues);
					
					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_QUESTIONGROUPS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
						dispatch('appStore/setLoading', -1, { root: true });
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getQuestionGroups');
						dispatch('appStore/setLoading', -1, { root: true });
					}
				})
				.catch(err => {
					console.log('Error getting questionGroups: ', err);
				});
		},

		async getListQuestionGroups({ commit, dispatch }, search) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				name: search,
				orderBy: 'name',
				currentPage: 1,
				pageSize: 10
			};

			return await questionGroupService
				.getQuestionGroups(searchParams)
				.then(data => {
					commit('SET_LIST_QUESTIONGROUPS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting questionGroups: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createQuestionGroup({ dispatch }, questionGroup) {
			return await questionGroupService
				.createQuestionGroup(questionGroup)
				.then(() => {
					dispatch('getQuestionGroups');
				})
				.catch(err => {
					console.log('Error creating questionGroup: ', err);
				});
		},
		async updateQuestionGroup({ dispatch }, questionGroup) {
			return await questionGroupService
				.updateQuestionGroup(questionGroup)
				.then(() => {
					dispatch('getQuestionGroups');
				})
				.catch(err => {
					console.log('Error updating questionGroup: ', err);
				});
		},
		async deleteQuestionGroup({ dispatch }, questionGroup) {
			return await questionGroupService
				.deleteQuestionGroup(questionGroup.id)
				.then(() => {
					dispatch('getQuestionGroups');
				})
				.catch(err => {
					console.log('Error deleting questionGroup: ', err);
				});
		},

		setQuestionGroup({ commit }, questionGroup) {
			commit('SET_QUESTIONGROUP', questionGroup);
		},
		setQuestionGroups({ commit }, questionGroup) {
			commit('SET_QUESTIONGROUPS', questionGroup);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		questionGroups: state => {
			return state.questionGroups;
		},
		listQuestionGroups: state => {
			return state.listQuestionGroups;
		},
		questionGroup: state => {
			return state.questionGroup;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
